import lang from '../lang.json';
import routes from './routes';
import shared from './shared.json';
import feed from './feed.json';

export default { lang, routes, shared, feed };
